// const heroku = "https://calm-falls-29246.herokuapp.com/";
const apiUrl = "https://api.ismailkhayat.com/api/";
// const apiUrl = "http://localhost:8000/api/";
export default {
  get: async function (url, lang) {
    return new Promise(function (resolve, reject) {
      let xhr = new XMLHttpRequest();
      xhr.open("GET", apiUrl + url + "?lang=" + lang);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.responseType = "json";
      xhr.send();
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(xhr.response);
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText,
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText,
        });
      };
    });
  },
  post: async function (url, lang, body,token) {
    return await new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open("POST", apiUrl + url, true);
      xhr.setRequestHeader("Accept", "application/json");
      if (token) {
        xhr.setRequestHeader("Authorization", "Bearer " + token);
      }
      try {
        xhr.send(body);
        xhr.onloadend = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            let res;
            if (xhr.response) {
              res = JSON.parse(xhr.response);
            }
            resolve({
              status: xhr.status,
              response: res,
            });
            this.success = true;
          } else {
            reject({
              status: xhr.status,
              response: xhr.response ? JSON.parse(xhr.response) : null,
            });
            this.success = false;
          }
        };
      } catch (error) {
        throw new Error(error);
      }
    });
  },
};
